import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { Button } from '@components/main-components/button/Button';

export const LoadMore = ({
  loading,
  onClick,
  seating = false,
}: {
  loading: boolean;
  onClick: () => void;
  seating?: boolean;
}) => (
  <SeeMoreContainer seating={seating}>
    <Button
      variant="tertiary"
      loading={loading}
      size="M"
      label="Load more"
      onClick={onClick}
      deprecatedCSS={{
        minWidth: 72,
        padding: '11px 12px',

        div: {
          base: 'M',
          fontWeight: '600 !important',
        },
      }}
    />
  </SeeMoreContainer>
);

const SeeMoreContainer = styled('div', {
  left: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 18,

  '@tablet': {
    marginTop: 14,
  },

  variants: {
    seating: {
      true: {
        marginTop: 28,

        '@tablet': {
          marginTop: 14,
        },
      },
    },
  },
});
